import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class RodregList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
        };
        this.updateTimer = {};

        const { rodregStore } = this.props.stores;
        rodregStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { rodregStore } = this.props.stores;
        const { totalAppend, limit } = rodregStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = rodregStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                rodregStore.updateOffset(offset);
                await rodregStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { rodregStore } = this.props.stores;
        rodregStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { rodregStore } = this.props.stores;
        await rodregStore.saveField(id, field, value);
    }

    delete = async (event) => {
        const { serial } = event.target.dataset;
        const { rodregStore } = this.props.stores;
        await rodregStore.delete(serial);
        rodregStore.markDeleted(serial);
    }

    render() {
        const { loading, previewServer } = this.state;
        const { rodregStore } = this.props.stores;
        const { rodregs, queryFilter, saved, deleted } = rodregStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {rodregStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for rod registrations...'
                                    onInput={e => rodregStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => rodregStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {rodregStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => rodregStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {rodregStore.sort !== rodregStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => rodregStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('serial', '-')}>
                                                serial {util.getSortIcon('serial', rodregStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 20%'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('articleno', '-')}>
                                                articleno {util.getSortIcon('name', rodregStore.articleno)}
                                            </span>
                                        </th>
                                        <th style='width: 30%'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('dealerName', '-')}>
                                                dealerName {util.getSortIcon('dealerName', rodregStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 20%'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('userEmail', '')}>
                                                userEmail {util.getSortIcon('userEmail', rodregStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('purchase_date', '')}>
                                                purchase_date {util.getSortIcon('purchase_date', rodregStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => rodregStore.toggleSort('received_date', '')}>
                                                received_date {util.getSortIcon('received_date', rodregStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rodregs && rodregs.map(rodreg => (
                                        <tr class={`${style.tableline} ${deleted[rodreg.serial] ? 'text-muted' : ''}`} style={`${deleted[rodreg.serial] ? 'text-decoration: line-through;' : ''}`}>
                                            <td>
                                                {!deleted[rodreg.serial] ? <a href={`/rodregs/${rodreg.serial}/Basics`}>{rodreg.serial}</a> : <span>{rodreg.serial}</span>}
                                            </td>
                                            <td>
                                                {rodreg.name}<br />
                                                <small class='text-muted'>
                                                    {rodreg.articleno}:
                                                    {rodreg.model}, {rodreg.length}, {rodreg.line}
                                                </small>
                                            </td>
                                            <td>
                                                {rodreg.dealerCustomerno}: {rodreg.dealerName}<br />
                                                {rodreg.registeredByDealer && <small class='text-muted'>
                                                    Registered by:<br />
                                                    {rodreg.registeredByDealer.customerno}: {rodreg.registeredByDealer.name}, {rodreg.registeredByDealer.email} 
                                                </small>}
                                            </td>
                                            <td>
                                                {rodreg.userEmail}: {rodreg.userFname} {rodreg.userLname}<br />
                                                <small class='text-muted'>
                                                    {rodreg.userAddress1}<br />
                                                    {rodreg.userPostalcode} {rodreg.userPostalplace}<br />
                                                    {rodreg.userCountry}
                                                </small>
                                            </td>
                                            <td class='text-right'>
                                                {rodreg.purchase_date && util.ffeDateTime(rodreg.purchase_date)}
                                            </td>
                                            <td class='text-right'>
                                                {rodreg.received_date && util.ffeDateTime(rodreg.received_date)}
                                            </td>
                                            <td>
                                                <nobr>
                                                    {!deleted[rodreg.serial] && <a class='btn btn-sm btn-danger' data-serial={rodreg.serial} onClick={this.delete}>
                                                        <i class={`fas fa-trash`} /> Delete
                                                    </a>}
                                                </nobr>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default RodregList;




// WEBPACK FOOTER //
// ./components/rodregs/list.js